import { BestPriceguarantee } from "../../../components/template/CustomTemplate/Pages/BestPriceguarantee";
import CustomTemplates from "../Deals/CustomTemplate";

const BestPriceGuaranteePage = () => {
  return (
    <CustomTemplates
      slug={"best-price-guarantee"}
      attributes={BestPriceguarantee}
    />
  );
};

export default BestPriceGuaranteePage;
